import API from '../../../services/apiService.js'
var api= new API();


export default {

  // Загрузить данные по активациям
  async loadChartData ({ commit }, lastDays) {
    var data=null;
    try{
      let getParams= `?DaysCount=${lastDays}`
      data = await api.Get("Statistic/BonusActivationGraphic"+getParams);
      return data
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },
    // Загрузить данные по партнерам
    async loadPopPartners ({ commit }, params) {
        var data=null;
        try{
            let getParams= `?DaysCount=${params.lastDays}&UseLimit=${params.isLimit}`
            data = await api.Get("Statistic/BonusPopularPartners"+getParams);
            commit('loadPopPartners', data);
        }catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    // Загрузить данные по клиентам
    async loadPopClients ({ commit }, params) {
        var data=null;
        try{
            let getParams= `?DaysCount=${params.lastDays}&UseLimit=${params.isLimit}`
            data = await api.Get("Statistic/BonusActiveClients"+getParams);
            commit('loadPopClients', data);
        }catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    // Загрузить данные по активациям
    async loadActivatesList ({ commit }, isLimit) {
        var data=null;
        try{
            let getParams= `?UseLimit=${isLimit}`
            data = await api.Get("Statistic/BonusActivationList"+getParams);
            commit('loadActivatesList', data);
        }catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    // Загрузить сводные данные по активациям
    async loadSummary ({ commit }) {
        var data=null;
        try{
            data = await api.Get("Statistic/BonusActivationTotal");
            return data
        }catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

}
